import React, { useContext } from "react";
import { AlertBox, Content, Message, Header } from "./style";
import CloseIcon from "../NetworkErrorAlert/close.svg";
import ErrorIcon from "./ErrorIcon";

import { ErrorAlertContext } from "../../../../context/ErrorAlertContext";
import { Overlay } from "../NetworkErrorAlert/style";

type AlertData = {
    title?: string;
    message: string;
};

const AlertComponent = ({
    alertData,
}: {
    alertData: AlertData;
}) => {
    const { onClose } = useContext(ErrorAlertContext);

    return (
        <Overlay>
            <AlertBox>
                <Content>
                    <ErrorIcon/>
                    <div>
                        {alertData.title && (
                            <Header>
                                {alertData.title}
                            </Header>
                        )}
                        <Message>{alertData.message}</Message>
                    </div>
                    <button onClick={onClose} className="close-icon">
                        <img src={CloseIcon}  />
                    </button>
                </Content>
            </AlertBox>
        </Overlay>
    );
};

const ErrorToastAlert = () => {
    const { showAlert, alertData } = useContext(ErrorAlertContext);

    if (!showAlert || !alertData) return null;

    return <AlertComponent alertData={alertData} />;
};

export default ErrorToastAlert;